const constants = {
  apiUrl: 'https://dev.editor.video.wiki',
  url: 'https://decast.live',
  backImageUrl: 'https://api.cast.video.wiki/api/photos/?category=',
  apiCastUrl: 'https://api.cast.decast.live',
  apiRoomUrl: 'https://api.room.video.wiki',
  streamUrl: 'https://play.stream.decast.live/hls/',
  eventDetailsUrl:
    'https://api.cast.video.wiki/api/event/meeting/info/?public_meeting_id=',
  oneClickPass: '5ZfEb9iu.6YVrCXR Up7x62bqTyK0cjHrgOOasBsWT',
  contractAddress: '0x15a0b4bba8e561f13c3c1d2acd5954b7e871cfb0',
  apiKey: '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',
  web3ApiKey:
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJkaWQ6ZXRocjoweDYxZUMxQTlhMDc5NDNlQjBjMTcwQWZhMjcxNTY4MTg4NDA5YzAyRWIiLCJpc3MiOiJ3ZWIzLXN0b3JhZ2UiLCJpYXQiOjE2NzA5NDQ2OTA5MjUsIm5hbWUiOiJiZWx1Z2EifQ.A2JdUCF0vKXJXGlaTKJ1pBNIDLT2MWa4m8OGHpCWfIA',
  profilingUrl: 'https://openid.video.wiki',
  pinataKey:
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySW5mb3JtYXRpb24iOnsiaWQiOiI4MjY5M2EwZS1jYWY2LTRjNzUtYWZkNC1iNTQ1ZGQ4MDNmNWEiLCJlbWFpbCI6Inp0ZWNoOTE4QGdtYWlsLmNvbSIsImVtYWlsX3ZlcmlmaWVkIjp0cnVlLCJwaW5fcG9saWN5Ijp7InJlZ2lvbnMiOlt7ImlkIjoiRlJBMSIsImRlc2lyZWRSZXBsaWNhdGlvbkNvdW50IjoxfSx7ImlkIjoiTllDMSIsImRlc2lyZWRSZXBsaWNhdGlvbkNvdW50IjoxfV0sInZlcnNpb24iOjF9LCJtZmFfZW5hYmxlZCI6ZmFsc2UsInN0YXR1cyI6IkFDVElWRSJ9LCJhdXRoZW50aWNhdGlvblR5cGUiOiJzY29wZWRLZXkiLCJzY29wZWRLZXlLZXkiOiIxNThkMTdiYTRmYTUzODQ0NWFmYSIsInNjb3BlZEtleVNlY3JldCI6ImQ0MTJjOGVhOGJiZGNiZjljYjkwN2U5OWVmNGJkMTVkNGM0OTgyZTQ2YTIyNmE0NmU2MTViNzJmYzg1ZDZjYjQiLCJpYXQiOjE3MDQyNzU5OTV9.Bit4dIaEVZHYTcNOpSBC6tRjK88WbmusoUwIXTmoJKQ',
  posthogKey: '',
  authApiBaseUrl: 'https://did.decast.live',
  googleLoginKey:
    '1037671469394-tdmicsdhp473pheeu3mj29ob2voc5bfr.apps.googleusercontent.com',
  didManagerExtensionKey: 'algkhhfaciplhfnkmecpmdfampkppndj',

  clientDomain: 'https://app.beta.decast.live',
  roomDomain: 'https://beta.live1.decast.live',
  transcriptionBaseUrl: 'https://api.transcription.decast.live',
  widBaseUrl: 'https://wid.decast.live',
  // decast-stripe-service, proxied by nginx on decast-prod (no separate host or cert)
  stripeServiceUrl: 'https://app.decast.live/billing',
};

if (process.env.NODE_ENV === 'production') {
  constants.apiUrl = 'https://dev.editor.video.wiki';
  constants.url = 'https://decast.live';
  constants.backImageUrl = 'https://api.cast.video.wiki/api/photos/?category=';
  constants.streamUrl = 'https://play.stream.decast.live/hls/';
  constants.eventDetailsUrl =
    'https://api.cast.video.wiki/api/event/meeting/info/?public_meeting_id=';
  constants.apiCastUrl = 'https://api.cast.decast.live';
  constants.apiRoomUrl = 'https://api.room.video.wiki';
  constants.clientDomain = 'https://app.decast.live';
  constants.roomDomain = 'https://live1.decast.live';
}

// if (process.env.NODE_ENV === 'production') {
//   constants.apiUrl = 'https://api.video.wiki',
//   constants.url = 'https://videowiki.pt',
//   constants.backImageUrl = "https://api.cast.video.wiki/api/photos/?category=",
//   constants.apiCastUrl = 'https://api.cast.video.wiki',
//   constants.streamUrl = "https://play.stream.decast.live/live/";
//   constants.eventDetailsUrl = "https://api.cast.video.wiki/api/event/meeting/info/?public_meeting_id="
// }

export default constants;
